import { merge } from "lodash";

import type { Permission } from "~/types/auth.type";

import { managerBoilerRoomPermissions } from "./manager-boiler-room.constant";

export const ownerPermissions: Permission = merge<Permission, Permission>(
  JSON.parse(JSON.stringify(managerBoilerRoomPermissions)) as Permission,
  {
    valve: {
      heatingNetworkId: { update: true, create: true },
    },
    gateway: {
      name: { update: true },
    },
    page: {
      users: true,
    },
    building: {
      delete: true,
      preComfortTemperature: { update: true },
      absenceTemperature: { update: true },
      frostFreeTemperature: { update: true },
      summerModePeriod: { update: true },
      name: { update: true },
      longitude: { update: true },
      latitude: { update: true },
      weatherStationId: { update: true },
      referencePeriod: { update: true },
    },
  },
);
